import { useEffect } from 'react';

import { collectFingerprints, type PaymentOption } from '@src/domains/payments';
import { setupFingerprint } from '@src/features/payments/utils/setupFingerprint';

type Input = {
  options: PaymentOption[];
  ready: boolean;
};

// Each script is injected once, when the list settles. `ready` is the only dependency on purpose:
// the options array is read at that moment, and re-running on every identity change would inject
// duplicates.
export const usePaymentFingerprints = ({ options, ready }: Input) => {
  useEffect(() => {
    if (!ready) {
      return;
    }

    collectFingerprints(options).forEach((fingerprint) => setupFingerprint(fingerprint));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ready]);
};
